import React from 'react';
import PropTypes from 'prop-types';
import NumberDisplay from '../number-display';

function NumberRenderer(props) {
  const { value, precision, suffix, suffixIsUnit } = props;
  let e = (
    <NumberDisplay value={value} precision={precision} suffix={suffix} suffixIsUnit={suffixIsUnit} />
  );
  if (suffix === '%' && (value === 0 || value === 100) ) {
    e = (<span>{value}{suffix}</span>);
  }
  if (props.onClick) {
    return (
      <a href="" onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        props.onClick(props.data);
      }}>{e}</a>
    );
  }

  return e;
}

NumberRenderer.propTypes = {
  value: PropTypes.number,
  precision: PropTypes.number,
  suffix: PropTypes.string,
  suffixIsUnit: PropTypes.bool,
  onClick: PropTypes.func,
};
NumberRenderer.defaultProps = {
  value: null,
  precision: 0,
  suffix: null,
  suffixIsUnit: false,
  onClick: null,
};

export default NumberRenderer;
